module.exports = __webpack_public_path__ + "img/logo-text.d9b4a981.png";